import { render, staticRenderFns } from "./Metroidvania.vue?vue&type=template&id=9d8e5ca2"
import script from "./Metroidvania.vue?vue&type=script&lang=js"
export * from "./Metroidvania.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports